<template>
  <Dialog :open="modelValue" @update:open="$emit('update:modelValue', false)">
    <DialogContent class="sm:max-w-[425px]">
      <DialogHeader>
        <DialogTitle class="text-lg font-medium">Issue Warning</DialogTitle>
        <DialogDescription class="text-sm text-gray-600">
          Review and confirm warning issuance. This action will mark the report as approved.
        </DialogDescription>
      </DialogHeader>
      <div class="grid gap-4 py-4">
        <div class="grid gap-2">
          <Label class="text-sm font-medium" for="severity">Severity <span class="text-red-500">*</span></Label>
          <Select v-model="form.severity">
            <SelectTrigger class="bg-white">
              <SelectValue placeholder="Select severity level" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="MINOR">Minor</SelectItem>
              <SelectItem value="MODERATE">Moderate</SelectItem>
              <SelectItem value="MAJOR">Major</SelectItem>
            </SelectContent>
          </Select>
        </div>
        <div class="grid gap-2">
          <Label class="text-sm font-medium" for="review_notes">Review Notes (Optional)</Label>
          <Textarea
            id="review_notes"
            v-model="form.review_notes"
            placeholder="Add any additional notes about this warning"
            class="bg-white resize-none h-24"
          />
        </div>
      </div>
      <DialogFooter class="flex justify-end gap-2">
        <Button variant="outline" class="text-sm" @click="$emit('update:modelValue', false)">Cancel</Button>
        <Button
          variant="destructive"
          :disabled="!form.severity || isSubmitting"
          @click="handleSubmit"
          class="w-fit flex items-center gap-2 text-sm"
        >
          <Loader2 v-if="isSubmitting" class="h-4 w-4 animate-spin" />
          Issue Warning
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
</template>

<script setup lang="ts">
import { ref } from 'vue'
import { Button } from '@/components/ui/button'
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter
} from '@/components/ui/dialog'
import { Textarea } from '@/components/ui/textarea'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from '@/components/ui/select'
import { Loader2 } from 'lucide-vue-next'

const props = defineProps<{
  modelValue: boolean
  isSubmitting: boolean
}>()

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'submit', data: { severity: string; review_notes?: string }): void
}>()

const form = ref({
  severity: '',
  review_notes: ''
})

const handleSubmit = () => {
  if (!form.value.severity) return
  emit('submit', {
    severity: form.value.severity,
    review_notes: form.value.review_notes || undefined
  })
  form.value = { severity: '', review_notes: '' }
}
</script> 